"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lruMemoize = require("lru-memoize");

var _lruMemoize2 = _interopRequireDefault(_lruMemoize);

var _validation = require("../../utils/validation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var feebackValidator = (0, _validation.createValidator)({
  email: [_validation.required, _validation.email],
  message: [_validation.required]
});
exports.default = (0, _lruMemoize2.default)(10)(feebackValidator);
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Feedback/feedbackValidator.js
 ** module id = 1214
 ** module chunks = 0
 **/